import { ContainerModule } from '@evertel/di'
import { MediaController } from './controller'

const DI_MODULES = new ContainerModule((m) => {
    m.bind(MediaController).toSelf()
})

export { DI_MODULES }

